import React from 'react';
import { makeStyles } from '~/lib/bn-material-ui';
import { muiTheme } from '~/utility/BinSentry-ui-utility';
import classnames from 'classnames';

const useStyles = makeStyles<typeof muiTheme>(({ palette }) => ({
  bookmark: {
    display: 'inline-block',
    justifyContent: 'flex-start',
    backgroundColor: palette.teal[30],
    color: palette.white,
    fontWeight: 600,
    padding: '0 1.5em 0 0.5em',
    borderRadius: '4px 4px 0 0',
    boxShadow: '-2px -2px 2px 0px rgba(0, 0, 0, 0.05)',
  },
}));

export function BnBookmark({
  title,
  className,
}: {
  title?: string,
  className?: string,
}) {
  const styles = useStyles();

  return <span className={classnames(styles.bookmark, className)}>
    {title}
  </span>;
}
